import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setStatus } from 'views/function/attendance/overtime-request-form/OvertimeRequestFormDocumentFormSlice';

export const NotificationMessage = ({ message = 'Information', status = 'info' }) => {
  if (status === 'info') {
    toast(message);
  } else if (status === 'success') {
    toast(message, { className: 'success' });
  } else if (status === 'warning') {

    toast(message, { className: 'warning' });
  } else if (status === 'error') {
    console.log(status);
    toast(message, { className: 'danger' });
  } else {
    toast(message);
  }
};
